





















import { Component, Vue, Prop } from 'vue-property-decorator';
import AppStore from '@/store/AppStore';

@Component({
  components: {},
})
export default class Topbar extends Vue {
  @Prop() public noPadding!: boolean;
  @Prop() public transparent!: boolean;
  @Prop() public hideSearch!: boolean;

  public goToSearch() {
    this.$router.push({ name: 'search', params: { returnRoute: this.$route.name || 'home' } });
  }

  public openMenu() {
    AppStore.ShowMenu();
  }
}
